import React, { Component } from 'react'
import {
    Link,
    Redirect
} from 'react-router-dom'
import { AppContext } from '@lightspeed-invoicing/core-client/frontend'
import { FormattedMessage, injectIntl, defineMessages } from 'react-intl'
import ImageUploaderDropZone from '../../common/image-uploader/dropzone.component.jsx'
import AddressFormFields from "../../customer/components/AddressFormFieldsComponent";

const messages = defineMessages({
    "companyDescription.form.edit.save_btn": {
        id: 'companyDescription.form.edit.save_btn',
        defaultMessage: 'Save',
    },
    "company_name_placeholder": {
        id: 'companyDescription.form.edit.name_placeholder',
        defaultMessage: 'Name of the company',
    },
    "company_phone_number_placeholder": {
        id: 'companyDescription.form.edit.phone_number_placeholder',
        defaultMessage: 'Phone number',
    },
    "company_email_placeholder": {
        id: 'companyDescription.form.edit.email_placeholder',
        defaultMessage: 'Email',
    }
})

class CompanyDetailsEditForm extends Component {

    constructor(props, context) {
        super(props, context);
        this.state = {
            formStatus: '',
            companyName: this.props.companyName,
            companyPhoneNumber: this.props.companyPhoneNumber,
            companyEmail: this.props.companyEmail,
            companyDescriptionId: this.props.companyDescriptionId,
            companyLogoImageId: this.props.companyLogoImageId,
            companyLogo: this.props.companyLogo,
            address: {
                addressId: this.props.companyAddressId,
                street: this.props.companyStreet,
                street2: this.props.companyStreet2,
                city: this.props.companyCity,
                postalCode: this.props.companyPostalCode,
                state: this.props.companyState,
                stateCode: this.props.companyStateCode,
                country: this.props.companyCountry,
                countryCode: this.props.companyCountryCode,
            },
        }
        this.handleFormChange = this.handleFormChange.bind(this)
        this.saveCompanyDescription = this.saveCompanyDescription.bind(this);
        this.submitCompanyDescription = this.submitCompanyDescription.bind(this);
        this.handleLogoChange = this.handleLogoChange.bind(this);
        this.handleAddressChange = this.handleAddressChange.bind(this)
    }


    handleLogoChange(images) {
        if (images.length > 0) {
            this.setState({
                companyLogoImageId: images[0].id,
                companyLogo: images[0],
            })
        } else {
            this.setState({
                companyLogoImageId: '',
                companyLogo: null,
            })
        }
    }


    saveCompanyDescription() {
        if (this.props.companyDescriptionId) {
            let updates = {
                "companyLogoImageId": this.state.companyLogoImageId,
                "organization":
                {
                    "name": this.state.companyName,
                    "phoneNumbers": [{
                        "type": "primary",
                        "phoneNumber": this.state.companyPhoneNumber,
                        "extension": ""
                    }],
                    "email": this.state.companyEmail,
                    "address": { ...this.state.address },
                }
            }
            const allowedFormFields = [
                "companyName",
                "city",
                "postalCode",
                "state",
                "stateCode",
                "country",
                "countryCode",
                "street",
                "street2",
                "companyPhoneNumber",
                "companyEmail",
                "companyDescriptionId",
                "companyLogoImageId",
            ]

            for (let i = 0; i < allowedFormFields.length; i++) {
                let field = allowedFormFields[i]
                if (this.state[field] !== this.props[field]) {
                    switch (field) {
                        case 'companyName':
                            updates["organization"]["name"] = this.state[field]
                            break;
                        case 'city':
                            updates["organization"]["address"]["city"] = this.state.address[field]
                            break;
                        case 'postalCode':
                            updates["organization"]["address"]["postalCode"] = this.state.address[field]
                            break;
                        case 'state':
                            updates["organization"]["address"]["state"] = this.state.address[field]
                            break;
                        case 'stateCode':
                            updates["organization"]["address"]["stateCode"] = this.state.address[field]
                            break;
                        case 'country':
                            updates["organization"]["address"]["country"] = this.state.address[field]
                            break;
                        case 'countryCode':
                            updates["organization"]["address"]["countryCode"] = this.state.address[field]
                            break;
                        case 'street':
                            updates["organization"]["address"]["street"] = this.state.address[field]
                            break;
                        case 'street2':
                            updates["organization"]["address"]["street"] = this.state.address[field]
                            break;
                        case 'companyPhoneNumber':
                            if (this.state[field]) {
                                updates["organization"]["phoneNumbers"] =
                                    [{
                                        "type": "primary",
                                        "phoneNumber": this.state[field],
                                        "extension": ""
                                    }]
                            }
                            break;
                        case 'companyEmail':
                            updates["organization"]["email"] = this.state[field]
                            break;
                        case 'companyLogoImageId':
                            updates["companyLogoImageId"] = this.state[field]
                            break;
                        default:
                            console.log('This field does not belong to a company description');
                    }
                }
            }
            return AppContext.getApiClient().patch('/accounts/company-descriptions/' + this.props.companyDescriptionId, updates);
        }
    }

    submitCompanyDescription(event) {
        this.saveCompanyDescription().then((response) => {
            if (!response.error) {
                this.setState({ formStatus: <Redirect to={{ pathname: '/settings' }} /> })
            }
        })

        event.preventDefault()
    }

    handleFormChange(event) {
        const target = event.target;
        const value = target.type === 'checkbox' ? target.checked : target.value;
        const name = target.name;

        this.setState({
            [name]: value
        });
    }

    handleAddressChange(change) {
        this.setState({
            address: {
                ...this.state.address,
                ...change,
            },
        })
    }

    render() {

        const images = []
        if (this.state.companyLogo) {
            images.push(this.state.companyLogo)
        }
        return (
            <form onSubmit={this.submitCompanyDescription}>
                <div className="row ui-has-modules">
                    <div className="col-12 ui-module">
                        <div className="d-flex">
                            <div className="flex-fill p-2">
                                <label className="form-label" htmlFor="companyName">
                                    <FormattedMessage
                                        id="companyDescription.form.edit.name_label"
                                        defaultMessage="Name"
                                    />
                                </label>
                                <input name="companyName"
                                    value={this.state.companyName}
                                    onChange={this.handleFormChange}
                                    id="companyName" type="text"
                                    className="form-control"
                                    placeholder={this.props.intl.formatMessage(messages["company_name_placeholder"])} />
                            </div>
                        </div>

                        <AddressFormFields value={this.state.address} onChange={this.handleAddressChange} />

                        <div className="d-flex">
                            <div className="flex-fill p-2">
                                <label className="form-label"
                                    htmlFor="companyPhoneNumber">
                                    <FormattedMessage
                                        id="companyDescription.form.edit.phone_number_label"
                                        defaultMessage="Phone number"
                                    />
                                </label>
                                <input name="companyPhoneNumber"
                                    value={this.state.companyPhoneNumber}
                                    onChange={this.handleFormChange}
                                    id="companyPhoneNumber"
                                    type="text"
                                    className="form-control"
                                    placeholder={this.props.intl.formatMessage(messages["company_phone_number_placeholder"])} />
                            </div>
                        </div>

                        <div className="d-flex">
                            <div className="flex-fill p-2">
                                <label className="col-form-label" htmlFor="companyEmail">
                                    <FormattedMessage
                                        id="companyDescription.form.edit.email_label"
                                        defaultMessage="Email"
                                    />
                                </label>
                                <input name="companyEmail"
                                    value={this.state.companyEmail}
                                    onChange={this.handleFormChange}
                                    id="companyEmail"
                                    type="email"
                                    className="form-control"
                                    placeholder={this.props.intl.formatMessage(messages["company_email_placeholder"])} />
                            </div>
                        </div>

                        <div className="d-flex">
                            <div className="flex-fill p-2">
                                <label className="form-label" htmlFor="companyName">
                                    <FormattedMessage
                                        id="companyDescription.form.edit.company_logo_label"
                                        defaultMessage="Company logo"
                                    />
                                </label>
                                <ImageUploaderDropZone
                                    onUpdateImageList={this.handleLogoChange}
                                    maxFiles={1}
                                    images={images}
                                />
                            </div>
                        </div>
                    </div>

                    {this.state.formStatus}

                    <div className="col-12 ui-module">
                        <div className="row">
                            <div className="col-6 text-align-right">
                                <Link to="/settings" className="btn btn-light">
                                    <FormattedMessage
                                        id="companyDescription.form.edit.cancel_btn"
                                        defaultMessage="Cancel"
                                    />
                                </Link>
                                &nbsp;
                                &nbsp;
                                <input type="submit"
                                    value={this.props.intl.formatMessage(messages['companyDescription.form.edit.save_btn'])}
                                    className="btn btn-primary" />
                            </div>
                        </div>
                    </div>
                </div>
            </form>
        );
    }
}

export default injectIntl(CompanyDetailsEditForm)


// WEBPACK FOOTER //
// ./src/settings/companyDetails/companyDetailsEditForm.component.jsx